export const processPages = {
  source: {
    title: "SOURCE",
    headline: "Begin with the buyer's requirement.",
    intro: "UGI starts with the product, sector, specification and destination market an international buyer wants to explore from India.",
    sections: [
      ["Buyer brief", "Share the product, category, specification, destination and any reference material that defines the requirement."],
      ["Requirement clarity", "The enquiry is organised around the buyer's stated need rather than a fixed catalogue."],
      ["Sourcing conversation", "UGI reviews the requirement and begins the appropriate India-linked sourcing conversation."],
    ],
  },
  connect: {
    title: "CONNECT",
    headline: "Create the right trade conversation.",
    intro: "UGI connects international buying requirements with relevant India-focused trade discussions, guided by the scope of each enquiry.",
    sections: [
      ["Enquiry context", "Buyer requirements are reviewed with the market, product and intended destination in view."],
      ["Relevant dialogue", "The conversation is shaped around the requirement rather than a generic introduction."],
      ["Next-step clarity", "Buyers receive a clear route for continuing the discussion with UGI."],
    ],
  },
  facilitate: {
    title: "FACILITATE",
    headline: "Bring structure to the next step.",
    intro: "UGI helps organise the information and communication needed to move a trade enquiry forward with clarity.",
    sections: [
      ["Requirement alignment", "Product details, destination expectations and buyer questions are kept visible."],
      ["Documentation discussion", "Relevant documentation needs can be identified as part of the enquiry conversation."],
      ["Coordinated progress", "The next steps remain clear as the opportunity is reviewed."],
    ],
  },
  expand: {
    title: "EXPAND",
    headline: "Explore markets beyond the first enquiry.",
    intro: "UGI supports buyer-led conversations that may extend from India toward GCC, African and wider global market opportunities.",
    sections: [
      ["Market direction", "Buyers can identify the regions they want to reach or explore."],
      ["Corridor perspective", "India, GCC, Africa and global routes remain part of UGI's trade narrative."],
      ["Opportunity review", "New-market possibilities are considered according to the buyer's product and destination brief."],
    ],
  },
};
